// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.intrastats', {
        url: '/intrastats?searchTerm',
        views: {
            'productList@product': {
            templateUrl: 'main/product/intrastats/intrastats.tpl.html',
            controller: 'IntrastatsController as vm'
        }},
        resolve: {
            intrastats: intrastatsResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function intrastatsResolver(IntrastatApiService, $stateParams) {
    return IntrastatApiService.getIntrastats({ page: 0, searchTerm: $stateParams.searchTerm, itemsPerPage: 20});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}
// @ngInject
function IntrastatsController($rootScope, $state, $scope, intrastats, IntrastatApiService, loadSpinnerService, searchTerm) {
    var vm = this;


    vm.intrastats = intrastats;
    vm.selectedIntrastatId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.intrastatId; }, function(newValue, oldValue) {
            vm.selectedIntrastatId = parseInt($state.params.intrastatId,10);
        });
        $rootScope.$on('Intrastat.Inserted', function(event, response) {
        });
        $rootScope.$on('Intrastat.Updated', function(event, response) {
        });
        $rootScope.$on('Intrastat.Deleted', function(event, response) {
        });
        $rootScope.$on('Intrastat.Changed', function(event, response) {
            loadIntrastats();
        });
    }

    function loadIntrastats() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        IntrastatApiService.getIntrastats(request).then(function(response) {
            vm.intrastats = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadIntrastats();
    }

}

angular
    .module('product.intrastats', ['intrastat.api', 'intrastats.intrastat'])
    .config(stateConfig)
    .controller('IntrastatsController', IntrastatsController);
